import { IOT_ADMIN, IOT_AUTHORITY, DynamicConstants } from '@/constants';

import VueCompositionAPI, { computed, inject, readonly, ref } from '@vue/composition-api';
import Vue from 'vue';
Vue.use(VueCompositionAPI);

const profile = ref<any>();

export default function () {
  function setProfile(value: any | undefined) {
    profile.value = value;
  }

  const constants = inject<DynamicConstants>('constants');
  const isAdmin = computed(() => profile.value?.roles?.includes(IOT_ADMIN) ?? false);

  const isAuthority = computed(() => profile.value?.roles?.includes(IOT_AUTHORITY) ?? false);

  const inDmpOrganization = computed(() => constants?.dmpCvr?.includes(profile.value?.cvr));

  const isReadOnly = computed<boolean>(
    () =>
      profile.value?.isAuthorityExisting &&
      !profile.value?.roles.includes(IOT_ADMIN) &&
      !profile.value?.roles.includes(IOT_AUTHORITY)
  );

  return {
    profile: readonly(profile),
    setProfile,
    isAdmin,
    isAuthority,
    isReadOnly,
    roles: computed(() => profile.value?.roles),
    inDmpOrganization
  };
}
